import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { FormControl, Grid, Switch, TextField } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { API } from '@const'
import { PfSubPfSelect } from '@select'
import Decimal from 'decimal.js'
class EditRiskControlStatusDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskControlStatusDialog', options)
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    state = {
        dialogOpen: false,
        platfromGameWaterpool: {
            accumulated_profit: 0,
            accumulated_bet: 0
        }
    }

    OpenDialog(platfromGameWaterpool) {
        this.setState({
                dialogOpen: true,
                platfromGameWaterpool
        })
        this.pfSelect.setState({
            pfId: platfromGameWaterpool.pf_id
        })
    }

    calculateProfit(profit, bet) {
        const result =  new Decimal(1)
                            .minus(new Decimal(Number(profit)).dividedBy(new Decimal(Number(bet))))
                            .times(new Decimal(100))
                            .toString()
        return (isNaN(result) || result === Infinity) ? 0 :  Number((result * 100 | 0) / 100)
    }

    closeDialog() {
        this.setState({
            dialogOpen: false,
        })
    }

    handleConfirm() {  
        const params = {
            pf_id: this.pfSelect.state.pfId,
            game_code: this.state.platfromGameWaterpool.game_code,
            is_control: this.state.platfromGameWaterpool.is_control,
            oid: Number(this.state.platfromGameWaterpool.oid),
            control_rtp: Number(this.state.platfromGameWaterpool.control_rtp),
            probability_involvement: Number(this.state.platfromGameWaterpool.probability_involvement),
            accumulated_bet: Number(this.state.platfromGameWaterpool.accumulated_bet),
            accumulated_profit: Number(this.state.platfromGameWaterpool.accumulated_profit)
        }

        utils.apiRequest(
            'put',
            API.PLATFROM_GAME_WATERPOOL,
            params,
            (_data) => {
                this.props.onConfirm();
                this.closeDialog();
            },
            (_err) => {}
        )
    }

    PlatfromGameWaterpoolTextField = (params) => {
        const ruleData = {
            probability_involvement: {
                defaultValue: 30,
                verify: /^[0-9]*$/,              //需阻擋小數、負數、僅能輸入整數
                max: null,
                min: null,
                textLength: 20
            },
            control_rtp: {
                defaultValue: 4,
                verify: /^-?\d*(\.\d{0,2})?$/,   //可輸入小數、負數
                max: 100,
                min: -100,
                textLength: 20
            },
            accumulated_bet: {
                defaultValue: 0,
                verify: /^\d*\.?\d{0,2}$/,       //可輸入小數，需阻擋負數
                max: null,
                min: null,
                textLength: 20
            },
            accumulated_profit: {
                defaultValue: 0,
                verify: /^\d*\.?\d{0,2}$/,   //可輸入小數、負數
                max: null,
                min: null,
                textLength: 20
            }
        }
        return (
            <TextField
                id="standard-basic" 
                variant="standard" 
                value={
                    this.state.platfromGameWaterpool[params] === undefined
                        ? ruleData[params].defaultValue
                        : this.state.platfromGameWaterpool[params]    
                }
                onChange={(event) => {
                    let value = event.target.value;
                    // 字元長度排除 - 和 . 後若超過長度限制則不能再輸入
                    if (value.toString().replace('-', '').replace('.', '').length > ruleData[params].textLength) return
                    // 當前輸入的如果是.且前一位是負號則不能輸入. 防範有人輸入 -.123
                    if (value.charAt(value.length -1) === '.' && value.charAt(value.length -2) === '-') return
                    if (ruleData[params].verify.test(value)) {
                        // 若輸入第二位時且第一位為0則刪除0
                        if (value.length > 1 && value.charAt(0) === '0' && value.charAt(1) !== '.') {
                            value = value.substring(1)
                        }
                        // 有設定最大值且輸入大於則使用最大值
                        if (ruleData[params].max !== null && value > ruleData[params].max) {
                            value = ruleData[params].max
                        }
                        // 有設定最小值且輸入小於則使用最小值
                        if (ruleData[params].min !== null && value < ruleData[params].min) {
                            value = ruleData[params].min
                        }
                        this.setState({
                            platfromGameWaterpool: {
                                ...this.state.platfromGameWaterpool,
                                [ params ]: value
                            }
                        })
                    }
                }}
            />
        ) 
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle> { `${this.state.platfromGameWaterpool.game_name} - ${this.t('Title')}` } </DialogTitle>
                <DialogContent className={this.props.classes.dialogContent}>
                    <Grid container spacing={2}>
                        <FormControl  className={this.props.classes.formControl}>
                            <div className={this.props.classes.pfSubPfSelect}>
                                <PfSubPfSelect
                                    options={{
                                        hideAllPlatform: true,
                                        hideAutocomplete: true,
                                    }}
                                    onRef={(ref) => (this.pfSelect = ref)}
                                />
                            </div>
                                {/* 啟用狀態 */}
                                <div>
                                    {this.t('activeStatus')}
                                    <Switch
                                        checked={this.state.platfromGameWaterpool.is_control}
                                        color='primary'
                                        onChange={(value) => {
                                            this.setState({
                                                platfromGameWaterpool: {
                                                    ...this.state.platfromGameWaterpool,
                                                    is_control: value.target.checked
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                {/* 非自然開獎機率 */}
                                <div>
                                    <span className={this.props.classes.inputLabel}>
                                        {this.t('unnaturalWinningOdds')}
                                    </span>
                                    { this.PlatfromGameWaterpoolTextField('probability_involvement') }
                                    <span className={this.props.classes.inputLabel}>
                                        %
                                    </span>
                                </div>
                                {/* 啟動條件 */}
                                <div>
                                    <span className={this.props.classes.inputLabel}>
                                        {this.t('startJudge')} {this.t('profitRateIsLessThan')}
                                    </span>
                                    { this.PlatfromGameWaterpoolTextField('control_rtp') }
                                    <span className={this.props.classes.inputLabel}>
                                        %
                                    </span>
                                </div>
                                {/* 當前獲利率 */}
                                <div className={this.props.classes.profitability}>
                                    { this.t('currentProfitability') } {this.state.platfromGameWaterpool.current_profit_rate} %
                                </div>
                                {/* 累積總投注 */}
                                <div> 
                                    <span className={this.props.classes.inputLabel}>
                                        {this.t('currentCumulativeTotalBets')}
                                    </span>
                                    { this.PlatfromGameWaterpoolTextField('accumulated_bet') }
                                </div>
                                {/* 累積總獲利 */}
                                <div>
                                    <span className={this.props.classes.inputLabel}>
                                        {this.t('currentCumulativeTotalProfit')}
                                    </span>
                                    { this.PlatfromGameWaterpoolTextField('accumulated_profit') }
                                </div>
                                {/* 修改後獲利率 */}
                                <div className={this.props.classes.modifiedProfitRate}>
                                    { this.t('modifiedProfitRate') } { 
                                        this.calculateProfit(
                                            Number(this.state.platfromGameWaterpool.accumulated_profit),
                                            Number(this.state.platfromGameWaterpool.accumulated_bet)
                                        ) 
                                    } %
                                </div>
                        </FormControl>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.handleConfirm()} color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        dialogContent: {
            margin: theme.spacing(1),
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
        inputLabel: {
            position: 'relative',
            top: '7px',
            paddingRight: '10px',
        },
        profitability: {
            paddingTop: '30px'
        },
        modifiedProfitRate: {
            paddingTop: '30px',
            color: 'red'
        },
        pfSubPfSelect: {
            marginLeft: '-10px'
        },
        formControl: {
            margin: theme.spacing(1),
            marginBottom: '25px',
            width: '480px',
        }
    }
}

EditRiskControlStatusDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    onConfirm: PropTypes.func
}

export default hoc(styles)(EditRiskControlStatusDialog)
